import { updateActors, delayActor, deleteActors } from '../../actions/game/actor.actions'
import { logBattle } from '../../actions/game/battleLog.actions'
import calculateAction from '../../../utils/calculateAction'
import { checkSelectedTargetActor } from '../../actions/game/targetActor.actions'

const battleStatusMiddleware = ({ getState, dispatch }) => next => (action) => {
    const { processBattle } = action.meta || {}

    if (!processBattle) {
        next(action)
        return
    }
    switch (processBattle) {
        case 'calculate': {
            next(action)
            const { actors, targetActor } = getState()
            if (actors.length > 0) {
                const nextAction = calculateAction(actors, targetActor)
                const { actor } = nextAction

                dispatch(logBattle(nextAction))
                dispatch(delayActor(actor.ID, actor.stats.rate))

                if (nextAction.action.target) {
                    dispatch(updateActors(nextAction.action))
                }
            }
            break
        }

        case 'check': {
            next(action)

            const { actors: actorsToCheck } = getState()
            const realityCheck = () => {
                const affectedActors = actorsToCheck.map((actor) => {
                    const targetIsDead = (target) => {
                        const { hp: hpMax } = target.stats
                        const { damage: damageCurrent } = target.status
                        return (hpMax - damageCurrent <= 0)
                    }
                    if (targetIsDead(actor)) {
                        return actor
                    }
                    return null
                })
                const deadActors = affectedActors.filter(el => el != null)
                if (deadActors.length > 0) {
                    const actorsToDelete = deadActors.map((actor) => {
                        dispatch(logBattle({
                            actor,
                            action: {
                                target: actor,
                                type: 'death',
                            },
                        }))
                        return actor.ID
                    })
                    dispatch(deleteActors(actorsToDelete))
                    dispatch(checkSelectedTargetActor())
                }
            }
            realityCheck()
            break
        }

        default: {
            next(action)
        }
    }
}

export default battleStatusMiddleware
